/** @jsxImportSource @emotion/react */
import React, { useCallback, useState } from "react";
import { Receiver, GlobalStore } from "../../../store/global/GlobalStore";
import { placeholderText, resetReceiver } from "../../../utils/swapAndSendUtils";
import { addressInputStyle, inputToCss, receiverIconCss } from "../SwapAndSendStyle";
import styled from "@emotion/styled";

interface AddressInputProps {
  visible: boolean;
  handleOnInput: (inputValue: string) => void;
  receiver: Receiver;
}

export const AddressInput: React.FC<AddressInputProps> = ({ visible, handleOnInput, receiver }) => {
  const network = GlobalStore.useState(s => s.network);
  const receiverAvatar = GlobalStore.useState(s => s.receiver?.avatar);
  const [receiverInput, setReceiverInput] = useState("");
  const [inputTimeout, setInputTimeout] = useState(0);

  const iconToDisplay = useCallback(() => {
    if (receiverAvatar) {
      return (
        <img
          className="rounded-circle me-1"
          css={receiverIconCss}
          src={receiverAvatar}
          alt={"ENS Avatar"}
        />
      );
    }
    return;
  }, [receiverAvatar]);

  if (!visible) {
    return null;
  }

  return (
    <>
      <AddressInputContainer>
        <span css={inputToCss}>To</span>
        {iconToDisplay()}
        <input
          type="text"
          id="address-input"
          data-testid={"address-input"}
          css={addressInputStyle}
          spellCheck={false}
          autoComplete="off"
          placeholder={placeholderText(network)}
          value={receiver?.userInput ?? ""}
          onChange={e => {
            // onChange will run with right click + paste
            setReceiverInput(e.target.value);
            if (e.target.value === "") {
              resetReceiver();
            }
            handleOnInput(e.target.value);
            GlobalStore.update(s => {
              s.receiver.userInput = e.target.value;
              s.receiver.avatar = "";
              s.receiverError = "";
            });
          }}
          onKeyUp={() => {
            // onKeyup runs with ctrl/cmd + v or typing
            window.clearTimeout(inputTimeout);
            setInputTimeout(
              window.setTimeout(() => {
                handleOnInput(receiverInput);
              }, 500)
            );
          }}
        />
      </AddressInputContainer>
    </>
  );
};

const AddressInputContainer = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
`;
